import { RateGroup } from "../features/actuarial/rates-state";

export const getPlan = (data: any[]) =>
    data.find((item) => item.plan_id !== null || item.type === "plan");

export const getRiders = (data: any[]) =>
    data
        .filter((item) => item.rider_id !== null)
        .map((r) => ({
            rider_id: r.rider_id,
            rider_rate: r.amount || "0",
        }));

export const getAgeKey = (title: string) =>
    `age_${title.toLowerCase().replace(/\s*to\s*/g, "_").replace(/\s+/g, "_")}`;


export const ratesFormat18To65GCLI = (ratesOf1865: RateGroup[]) => {
    const bandKey = "18-65";

    const result: Record<string, any> = {
        [bandKey]: {
            basic_plan_id: null,
            basic_plan: [],
        },
    };

    ratesOf1865?.forEach((group) => {
        const plan = getPlan(group.data);
        const riders = getRiders(group.data);

        const term = Number(group.title.split(" ")[0]);

        if (!result[bandKey].basic_plan_id) {
            result[bandKey].basic_plan_id = plan?.plan_id ?? null;
        }

        result[bandKey].basic_plan.push({
            // term_or_months: term,
            term_of_months: term,
            basic_rate: plan?.amount || "0",
            riders,
        });
    });

    return result;
}